import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Base64 } from 'js-base64';
import $ from "jquery";
import { JurPerson } from '../../@core/data/jur-person';
import { AuthGuardService } from '../../@core/utils/auth-guard-service.service';

import { NbThemeService } from '@nebular/theme';
import { RestService } from '../../@core/utils/rest.service';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { formatDate } from '@angular/common';
import { Result } from '../../@core/data/result';
import Swal from 'sweetalert2';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { FormArrayName } from '@angular/forms';

import { Jsonp } from '@angular/http';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';

export class City{
    constructor(public id: number,
                public name: string)
    { }
}
class Appeal {

  public bin: string;
  public name: string;
  public question: string;
  public theme: string;
  public email: string;
  public region: string;
  public lang: string;

}
@Component({
    selector: 'ngx-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss']
})
export class CallbackComponent implements OnInit {
    jurBIN: any;
    jurName: any;
    lang: any;
    question: string = "";
    phone: string = "";
    city: string = "";
    date: string = "";
    public cities: City[];
    companies: string[] = [];
    saveButtonDisabled: Boolean = true;
    constructor(private http: HttpClient, public translate: TranslateService, public rest: RestService, private ngxService: NgxUiLoaderService){
      this.date = new Date().toISOString().slice(0, 16);
    }
    ngOnInit() {
        this.http.get('assets/cities.json').subscribe((data:string)=>{
            this.cities = <City[]>JSON.parse(JSON.stringify(data));
        });
        this.saveButtonDisabled = false;
        console.log(this.cities);
        console.log('Argentina');


    }
    addCallBack(){
        this.saveButtonDisabled = true;
        try {
            let pt = new Appeal();
            pt.lang = sessionStorage.getItem('lang');
            pt.bin = sessionStorage.getItem('IDN');
            pt.name = sessionStorage.getItem('nameJur');
            pt.theme = "Обратный звонок";
            pt.email = "";
            pt.question = "Время: "+ this.date + " \n Номер телефона: " + this.phone;
            pt.region = this.city;

            if (this.phone.length == 0) {
                Swal.fire({
                  text: this.translate.instant('ALERTEMPTYSAVE'),
                  type: 'error',
                  confirmButtonText: 'OK',
                  confirmButtonColor: "#008e54"
                });
                return;
            }
            let jsonString1 = JSON.stringify(pt);
            console.log(jsonString1);
            this.ngxService.start();
            this.rest.sendAppeal(jsonString1).subscribe((data: any) => {
              if (data.code == "-1") {
                Swal.fire({
                  text: data.message,
                  type: 'error',
                  confirmButtonText: 'OK',
                  confirmButtonColor: "#008e54"
                })
              }
              if (data.code == "0") {
                Swal.fire({
                  text: data.message,
                  type: 'success',
                  confirmButtonText: 'OK',
                  confirmButtonColor: "#008e54"
                })
              }
              if (data.code == "-4") {
                Swal.fire({
                  text: data.message,
                  type: 'error',
                  confirmButtonText: 'OK',
                  confirmButtonColor: "#008e54"
                })
              }
              this.ngxService.stop();
            },
              error => {
                this.ngxService.stop();
                console.log(error);
                Swal.fire({
                  text: this.translate.instant('ALERTTECHNICAL'),
                  type: 'error',
                  confirmButtonText: 'OK',
                  confirmButtonColor: "#008e54"
                })
              });
              this.saveButtonDisabled = false;
        }
        catch(e){
            this.ngxService.stop();
            console.log('Error was fixed= ' + e)
            Swal.fire({
              text: this.translate.instant('ALERTTECHNICAL'),
              type: 'error',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
            })
            this.saveButtonDisabled = false;
        }

        //this.cities.push(new City(this.price, this.title));
    }

}
